'use client'

import type { VariantProps } from 'class-variance-authority'
import { useTranslations } from 'next-intl'
import { useFormStatus } from 'react-dom'

import { LoaderIcon } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { buttonVariants } from '@/components/ui/button-variants'
import { cn } from '@/lib/utils'

export function SubmitButton({
  className,
  disabled,
  children,
  isSuccessful,
  variant = 'default',
}: {
  className?: string
  disabled?: boolean
  children: React.ReactNode
  isSuccessful: boolean
  variant?: VariantProps<typeof buttonVariants>['variant']
}) {
  const t = useTranslations('common')
  const { pending } = useFormStatus()

  return (
    <Button
      variant={variant}
      aria-disabled={pending || isSuccessful || disabled}
      className={cn('relative w-full font-sans text-sm font-medium md:text-sm', className)}
      disabled={pending || isSuccessful || disabled}
      type={pending ? 'button' : 'submit'}
    >
      {children}

      {(pending || isSuccessful) && (
        <span className="absolute right-4 animate-spin">
          <LoaderIcon />
        </span>
      )}

      <output aria-live="polite" className="sr-only">
        {pending || isSuccessful ? t('loading') : t('submitForm')}
      </output>
    </Button>
  )
}
